__turbopack_context__.v({
  "actions": "styles-module__VQBJya__actions",
  "checkButton": "styles-module__VQBJya__checkButton",
  "dialogContent": "styles-module__VQBJya__dialogContent",
  "field": "styles-module__VQBJya__field",
  "labelDivider": "styles-module__VQBJya__labelDivider",
  "labelDividerLine": "styles-module__VQBJya__labelDividerLine",
  "labelDividerText": "styles-module__VQBJya__labelDividerText",
  "labelDividerTrail": "styles-module__VQBJya__labelDividerTrail",
  "orderTotal": "styles-module__VQBJya__orderTotal",
  "paymentIcon": "styles-module__VQBJya__paymentIcon",
  "paymentRow": "styles-module__VQBJya__paymentRow",
  "searchBox": "styles-module__VQBJya__searchBox",
  "searchField": "styles-module__VQBJya__searchField",
});
